import { usePage } from '@inertiajs/react';

interface RouteSegments {
    book: string;
    genre: string;
    genres: string;
    author: string;
    authors: string;
}

export function useTranslatedRoutes() {
    const pageProps = usePage().props as any;
    // Ensure locale always has a valid value, defaulting to 'en'
    const locale = pageProps.locale || 'en';
    const routeSegments = pageProps.routeSegments || {};
    const translations = pageProps.translations || {};
    
    // Get route segments - prefer shared data, fallback to translations
    let segments: RouteSegments;
    
    if (routeSegments[locale]) {
        // Use route segments from shared data
        segments = routeSegments[locale];
    } else if (locale === 'en') {
        // Force English segments for English locale
        segments = {
            book: 'book',
            genre: 'genre',
            genres: 'genres',
            author: 'author',
            authors: 'authors',
        };
    } else {
        // Fallback to translated segments from translations
        segments = {
            book: translations['route.book'] || 'book',
            genre: translations['route.genre'] || 'genre',
            genres: translations['route.genres'] || 'genres',
            author: translations['route.author'] || 'author',
            authors: translations['route.authors'] || 'authors',
        };
    }
    
    
    // Always include the locale prefix in the path
    const basePath = `/${locale}`;
    
    return {
        locale,
        segments,
        
        // Helper functions to generate URLs
        bookUrl: (slug: string) => `${basePath}/${segments.book}/${slug}`,
        genreUrl: (slug: string) => `${basePath}/${segments.genre}/${slug}`,
        genresUrl: () => `${basePath}/${segments.genres}`,
        authorUrl: (slug: string) => `${basePath}/${segments.author}/${slug}`,
        authorsUrl: () => `${basePath}/${segments.authors}`,
        homeUrl: () => basePath,
    };
}